import { NavLink } from "react-router-dom";

const AuthLogoRedirect = ({ description }: { description: string }) => {
  return (
    <div className="underlined-off text-center">
      <div className="brand d-flex flex-column align-items-center">
        <NavLink to={"/"} className="d-inline-block">
          <img
            title="Super User Manager"
            loading="lazy"
            src="https://cdn.1cdn.app/application/UMD/2405110558455_logo.png"
            alt="Super User Manager"
            width={40}
            height={40}
            className="img-fluid mb-2"
          />
        </NavLink>
        <small className="mb-0">{description}</small>
      </div>
    </div>
  );
};

export default AuthLogoRedirect;
